<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('my_instructor_request')"
                        :isFilter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('my_instructor_request')"
                              :isFilter="false">
                </HeaderMobile>
            </template>
            <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
                <div class="tabs-bottom-line"></div>
                <b-tab>
                    <div class="d-flex justify-content-end mb-2">
                        <b-button
                            variant="primary"
                            class="mr-2"
                            @click="$router.push('/change-of-grade/request-form')"
                        >
                            {{$t('new_request')}}
                        </b-button>
                    </div>
                    <template #title><span class="d-flex align-items-center">{{ $t('change_of_grade_request') }}</span>
                    </template>
                    <b-table
                        :empty-text="this.$t('there_are_no_records')"
                        bordered
                        striped
                        responsive
                        :items="gradeChangeRequest"
                        :fields="gradeChangeRequestFields"
                        show-empty
                        class="mb-5 table-dropdown no-scrollbar border rounded"
                    >
                        <template #cell(semesters)="row"><span
                            class="d-flex align-items-center">{{ row.item.semesters }}</span>
                        </template>
                        <template #cell(steps)="row">
                            <span class="d-flex align-items-center justify-content-center" style="cursor:pointer">
                                <i class="ri-arrow-down-s-line"></i>
                            </span>
                        </template>
                        <template #row-details="data">
                            <b-table-simple responsive small class="table-bordered table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th class="text-center">{{ $t('rank').toUpperCase() }}</th>
                                        <th class="text-center">{{ $t('can_approvers').toUpperCase() }}</th>
                                        <th class="text-center">{{ $t('approved_by').toUpper() }}</th>
                                        <th class="text-center">{{ $t('status').toUpper() }}</th>
                                        <th class="text-center">{{ $t('explanation').toUpper() }}</th>
                                        <th class="text-center">{{ $t('updated_at').toUpper() }}</th>
                                    </tr>
                                </thead>
                                <b-tbody v-for="(item,i) in data.item.steps" :key="i">
                                    <tr>
                                        <td class="text-center">{{ i + 1 }}</td>
                                        <td>
                                            {{item.name}}
                                        </td>

                                        <td>
                                            <div v-for="(approved,i) in (getObjectValue(item,'approved',[]))" :key="i">
                                                {{
                                                    getObjectValue(approved, 'name') + ' ' + getObjectValue(approved, 'surname')
                                                }}
                                            </div>
                                        </td>


                                        <td>{{ item.status_name }}</td>


                                        <td>{{ getObjectValue(item, 'reason') }}</td>


                                        <td>{{ IsoDate(item.updated_at) }}</td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import CommonModal from "@/components/elements/CommonModal";
import {ValidationObserver, ValidationProvider} from "vee-validate";

import moment from 'moment';

import qs from "qs";
import GradeChangeService from "@/services/GradeChangeService";

export default {
    components: {
        MultiSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
        CommonModal,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            tabIndex: 0,
            slots: null,
            selectedCourseTransfer: null,
            studentApproveForm: {},
            gradeChangeRequest: [],
            gradeChangeRequestFields: [
                {key: 'student_name', label: this.toUpperCase('student_name')},
                {key: 'student_surname', label: this.toUpperCase('student_surname')},
                {key: 'course_name', label: this.toUpperCase('course_name')},
                {key: 'letter_grade', label: this.toUpperCase('letter_grade')},
                {key: 'new_letter_grade', label: this.toUpperCase('new_letter_grade')},
                {key: 'reason', label: this.toUpperCase('reason')},
                {key: 'status', label: this.toUpperCase('status')},
            ],
            stateData: {}
        }
    },
    metaInfo() {
        return {
            title: this.$t("my_instructor_request")
        }
    },
    methods: {
        loadData() {
            if (!this.stateData ) {
                return;
            }

            const config = {
                params: {
                    filter: {instructor_id: this.stateData.id},
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            GradeChangeService.getAll(config)
                .then(response => {
                    this.gradeChangeRequest = response.data.data;
                }).catch(e => {
                this.showErrors(e);
            })

        },
        IsoDate(date) {
            return moment(date).utc().format("MM/DD/YYYY HH:mm");
        },
    },
    created() {
        this.$store.dispatch("auth/initUser");
        this.stateData = {
            ...this.$store.getters['auth/getUser']
        }

        this.loadData();
        if (this.$route.params.tab) {
            this.tabIndex = parseInt(this.$route.params.tab)
        }
    },
}
</script>

<style lang="scss">
.document_request_dropdown {
    tr {
        td:first-child {
            padding-right: 0px !important;
        }
    }
}
</style>
